import { RootState } from 'types';
import { initialState } from '.';

export const selectWebsocketConnected = (state: RootState) => {
  return state?.conversations?.websocketConnected || initialState.websocketConnected;
};

export const selectConversationSummary = (state: RootState, conversationId: string) => {
  return (state?.conversations?.summaryPerConversation || initialState.summaryPerConversation)[conversationId] || '';
};

export const selectConversationSummaryDraft = (state: RootState, conversationId: string) => {
  return (
    (state?.conversations?.summaryDraftPerConversation || initialState.summaryDraftPerConversation)[conversationId] ||
    ''
  );
};

export const selectConversationInputText = (state: RootState, conversationId: string) => {
  return state?.conversations?.conversationInputTexts[conversationId];
};

export const selectReplyingToMessage = (state: RootState, conversationId: string) => {
  return state?.conversations?.replyingToMessage[conversationId];
};
